import { User } from "../../models/User";
import {CookiesTypes} from "../fetchTutors/types";

type FetchUnreadMessageNumberArgs = {
  userDetails: User;
  cookies: CookiesTypes;
  setUnreadMessageNumber: (unreadMessageNumber: number) => void;
};

export const fetchUnreadMessageNumber = async ({
  userDetails,
  cookies,
  setUnreadMessageNumber,
}: FetchUnreadMessageNumberArgs) => {
  const cookieString: string = cookies.sessionCookie + ";" +
      cookies.awsCookie + ";" +
      cookies.awsCorsCookie + ";"
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_BASE_URL}/chats/${userDetails.type}/${userDetails.id}/unread-message-count`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Cookie: cookieString
        },
      }
    );
    const data = await response.json();
    setUnreadMessageNumber(data?.unreadMessageCount);
  } catch (e) {
    console.warn(e);
  }
};
